




































































































import { Vue, Component, Prop } from "vue-property-decorator";
import { LearningRequestStatistic as ILearningRequestStatistic } from "@/api/models/learning-request-statistic";
import api from "@/getinfo-api";
import { getCurrentCompanyId, getCurrentEmployee } from "@/plugins/roles";

@Component
export default class Request extends Vue {
  @Prop({ default: true }) isNeedEmployee?: boolean;
  statistic!: ILearningRequestStatistic;
  showSpinner: boolean = false;

  data() {
    return {
      statistic: undefined
    };
  }

  get companyId() {
    return getCurrentCompanyId();
  }

  get currentEmployee() {
    return getCurrentEmployee();
  }

  created() {
    this.showSpinner = true;
    api.LearningRequestApi.getLearningRequestStatistic(
      this.companyId,
      this.isNeedEmployee ? this.currentEmployee.id : undefined
    )
      .then(res => {
        this.statistic = res.data;
      })
      .finally(() => (this.showSpinner = false));
  }
}
